import { render, staticRenderFns } from "./embryoDetails.vue?vue&type=template&id=a1ec2c48&scoped=true"
import script from "./embryoDetails.vue?vue&type=script&lang=js"
export * from "./embryoDetails.vue?vue&type=script&lang=js"
import style0 from "./embryoDetails.vue?vue&type=style&index=0&id=a1ec2c48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ec2c48",
  null
  
)

export default component.exports